import { GlSkeletonLoader } from '@gitlab/ui';
export default {
    name: 'PackagesListLoader',
    components: {
        GlSkeletonLoader
    },
    shapes: [
        {
            type: 'rect',
            width: '320',
            height: '12',
            x: '0',
            y: '12'
        },
        {
            type: 'rect',
            width: '240',
            height: '8',
            x: '0',
            y: '32'
        },
        {
            type: 'rect',
            width: '160',
            height: '12',
            x: '790',
            y: '12'
        },
        {
            type: 'rect',
            width: '140',
            height: '8',
            x: '790',
            y: '32'
        },
        {
            type: 'rect',
            width: '8',
            height: '20',
            x: '980',
            y: '16',
            ref: 'button-loader'
        }
    ],
    rowsToRender: {
        mobile: 5,
        desktop: 10
    }
};
